import { useMemo } from "react";

import { AfterMessageQuestion } from "components/SonicBot/schemas";
import { useGlobalsContext } from "shared/hooks";
import classNames from "shared/utils/classNames";
import replaceVariablesInString from "shared/utils/replaceVariablesInString";

type Props = {
  afterMessageQuestion: AfterMessageQuestion;
  onSuggestionClick: (
    afterMessageQuestion: AfterMessageQuestion,
  ) => Promise<void>;
  isOverButton?: boolean;
};

function StarterQuestionButton(props: Props) {
  const { afterMessageQuestion, onSuggestionClick, isOverButton } = props;

  const { variables } = useGlobalsContext();

  const question = useMemo(() => {
    return replaceVariablesInString(afterMessageQuestion.question, variables);
  }, [afterMessageQuestion, variables]);

  return (
    <button
      className={classNames(
        "message-button relative max-w-full break-words rounded-lg border border-solid border-[var(--borderColor)] bg-white",
        "cursor-pointer px-3 py-2 text-left text-[var(--chatBotOrDarkColor)] hover:bg-[var(--starterHoverColor)]",
        isOverButton ? "outside text-sm" : "inside text-xs",
      )}
      onClick={() => onSuggestionClick(afterMessageQuestion)}
    >
      <p>{question}</p>
      <div className="absolute inset-0 z-[-2] rounded-lg bg-white">&nbsp;</div>
    </button>
  );
}

export default StarterQuestionButton;
